import { render } from "./MvStartLogo.vue?vue&type=template&id=356d2098&scoped=true"
const script = {}

import "./MvStartLogo.vue?vue&type=style&index=0&id=356d2098&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-356d2098"]])

export default __exports__